<template>
  <div class="content">
    <h1 class="title">{{ $t("lockedItems.title") }}</h1>
    <div>
      <div class="table">
        <v-data-table
          v-if="!isLoading"
          :headers="headers"
          :items="lockedItemeEvents"
          disable-sort
          hide-default-footer
          :items-per-page="-1"
          class="elevation-0"
        >
          <template v-slot:[`item.date`]="{ item }">
            <td>
              {{ dateTimeFormat(item.selectable.date) }}
            </td>
          </template>
          <template v-slot:[`item.icon`]="{ item }">
            <v-btn
              @click="handleUnlock(item.selectable.id)"
              icon="mdi-lock-open"
              variant="text"
            ></v-btn>
          </template>
          <template v-slot:no-data>
            <Vue3Lottie
              :animationData="NoDataLottie"
              :height="200"
              :width="200"
            />
            <div class="pb-5 table-no-data">
              <h3>{{ $t("tableNoDataTitle") }}</h3>
              <p>{{ $t("tableNoDataDesc") }}</p>
            </div>
          </template>
          <template v-slot:bottom>
            <div class="botSide">
              <v-row
                align="center"
                justify-sm="end"
                justify="center"
                class="px-2"
              >
                <v-col cols="12" xs="12" lg="3" md="4" sm="6">
                  <v-row align="center" justify="end"
                    ><div class="pr-2 pageSelectorLabel">
                      {{ $t("anomaly.tableFooterText") }}
                    </div>
                    <v-select
                      v-model="limit"
                      hide-details
                      @update:model-value="handleFilter(false)"
                      :items="pageSizes"
                      class="pageSelector pl-5"
                    ></v-select>
                    <div class="pl-2">
                      {{ displayRange }}
                    </div>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  lg="3"
                  md="4"
                  sm="5"
                  class="pl-1 pr-1 pagination"
                >
                  <v-pagination
                    v-model="page"
                    :length="pageCount"
                    rounded="circle"
                    :total-visible="1"
                    show-first-last-page="true"
                    @update:model-value="handleFilter(true)"
                  ></v-pagination>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-data-table>
      </div>
      <v-card v-if="isLoading" class="loading">
        <v-progress-circular
          v-if="isLoading"
          size="73.5"
          indeterminate
          class="loading-circle"
        ></v-progress-circular>
      </v-card>
      <basic-confirm-modal
        :title="$t('lockedItems.confirmTitle')"
        :sub-title="$t('lockedItems.confirmQuestion')"
      ></basic-confirm-modal>
    </div>
  </div>
</template>

<script>
import { Vue3Lottie } from "vue3-lottie";
import NoDataLottie from "@/assets/lotties/nodatalottie.json";
import basicConfirmModal from "@/components/global/modalComponents/basicConfirmModal/basicConfirmModal.vue";
import { mapActions } from "vuex";
import { useToast } from "vue-toastification";
import moment from "moment";

const toast = useToast();

export default {
  name: "LockedItems",
  props: {},
  components: {
    basicConfirmModal,
    Vue3Lottie,
  },
  data() {
    return {
      NoDataLottie,
      headers: [
        {
          title: this.$t("lockedItems.table.headers.user_name"),
          key: "user.full_name",
          align: "start",
          sortable: false,
        },
        {
          title: this.$t("lockedItems.table.headers.product_name"),
          key: "product.name",
          sortable: false,
        },
        {
          title: this.$t("lockedItems.table.headers.date"),
          key: "date",
          sortable: false,
        },
        {
          title: this.$t("lockedItems.table.headers.icon"),
          key: "icon",
          align: "center",
          sortable: false,
        },
      ],

      //Pagination settings
      page: undefined,
      limit: undefined,
      total: 0,
      pageSizes: [10, 25, 50, 100],

      lockedItemeEvents: [],

      isLoading: false,
      error: false,
    };
  },
  created() {
    this.getLockedItemsMethod();
    this.emitter.on("basicConfirmModalConfirmed", (confirmedId) => {
      this.deleteLockedItems(confirmedId)
        .then(() => {
          toast.success(this.$t("lockedItems.succesUnlock"));
          this.getLockedItemsMethod();
        })
        .catch((err) => console.log(err));
    });
  },

  methods: {
    ...mapActions({
      getLockedItems: "locked_products/getLockedItems",
      deleteLockedItems: "locked_products/deleteLockedItems",
    }),
    getLockedItemsMethod(params) {
      this.isLoading = true;
      this.getLockedItems(params)
        .then((res) => {
          this.isLoading = false;
          this.lockedItemeEvents = res.list;
          this.page = res.page;
          this.limit = res.limit;
          this.total = res.total;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.error = true;
        });
    },
    handleFilter(hasPage) {
      const params = {
        limit: this.limit,
        page: hasPage ? this.page : 1,
      };
      this.getLockedItemsMethod(params);
    },
    handleUnlock(id) {
      this.emitter.emit("showBasicConfirmModal", id);
    },
    dateTimeFormat(dateTime) {
      return moment(dateTime).format("YYYY.MM.DD HH:mm:ss");
    },
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
    displayRange() {
      const start = (this.page - 1) * this.limit + 1;
      const end = Math.min(start + this.limit - 1, this.total);
      return `${start}-${end} of ${this.total}`;
    },
  },
  beforeUnmount() {
    this.emitter.off("basicConfirmModalConfirmed");
  },
};
</script>

<style lang="scss" scoped></style>
